export default __webpack_public_path__ + "static/media/attachmentDef.94031eca.svg";